// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YuAP","content":"styles_content__18GyK"};